export class DropdownModel {
  public label: string;
  public value: number;
  public additionalData?: string;
}